import React from 'react';
import { Size } from '../../../enums/size';
import { Color } from '../../../enums/color';
import { Spinner as DSSpinner } from '../spinner';
const colorMap = {
    white: 'white',
    blue: 'primary',
    gray: 'secondary',
    red: 'error',
    green: 'success',
    black: 'primary',
};
export const Spinner = ({ size = Size.Small, color = Color.Blue, velocity = 'normal', dataTest, }) => {
    return React.createElement(DSSpinner, { size: size, velocity: velocity, dataTest: dataTest, color: colorMap[color] });
};
//# sourceMappingURL=spinner.js.map